import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["bottomLinks"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import styled from 'styled-components';
import { Link as CoreLink, Box } from '@miro-site/core';
import HeaderContainer from './HeaderContainer';
import { jsx as _jsx } from "react/jsx-runtime";
var Link = styled(CoreLink).attrs(function (_ref) {
  var bottomLinks = _ref.theme.header.bottomLinks;
  return {
    $variant: bottomLinks.link.variant,
    $color: bottomLinks.link.color,
    $size: bottomLinks.link.size,
    withArrow: bottomLinks.link.withArrow,
    $styles: {
      marginRight: bottomLinks.gutter,
      borderBottom: bottomLinks.link.border
    }
  };
}).withConfig({
  displayName: "BottomLinks__Link",
  componentId: "sc-1j2vyjp-0"
})([""]);
var Wrapper = styled(Box).attrs(function (_ref2) {
  var header = _ref2.theme.header;
  return {
    $styles: {
      height: header.bottomLinks.height,
      paddingTop: header.bottomLinks.paddingTop,
      paddingBottom: header.bottomLinks.paddingBottom,
      borderTop: header.secondaryNavigation.stroke,
      background: header.bottomLinks.background
    }
  };
}).withConfig({
  displayName: "BottomLinks__Wrapper",
  componentId: "sc-1j2vyjp-1"
})(["position:absolute;width:100%;bottom:0;left:0;z-index:10;"]);

var BottomLinks = function BottomLinks(_ref3) {
  var bottomLinks = _ref3.bottomLinks,
      restProps = _objectWithoutProperties(_ref3, _excluded);

  return /*#__PURE__*/_jsx(Wrapper, _objectSpread(_objectSpread({}, restProps), {}, {
    children: /*#__PURE__*/_jsx(HeaderContainer, {
      children: bottomLinks.map(function (l) {
        return /*#__PURE__*/_jsx(Link, {
          href: l.path,
          children: l.title
        }, l.title);
      })
    })
  }));
};

export default Object.assign(BottomLinks, {
  Link: Link
});